
import type { PropOptions } from 'vue';
import Vue from 'vue';
import type { IPostTopic } from '@/types/community';
import TooltipArrow from '@/components/partials/war-room/WarRoomCategoryBadge/images/tooltip-arrow.vue.svg';

export default Vue.extend({
  name: 'WarRoomCategoryBadgeTopic',
  components: {
    TooltipArrow,
  },
  props: {
    topics: {
      type: Array,
      required: true,
    } as PropOptions<IPostTopic[]>,
  },
});
